import Vue from 'vue';

const strings = window.i18n;

export default Vue.filter('i18n', (value, args) => {
  let string = (strings == null || !strings.hasOwnProperty(value)) ? value : strings[value];

  if (args) {
    Object.keys(args).forEach((arg) => {
      const expr = new RegExp(`{${arg}}`, 'g');
      string = string.replace(expr, args[arg]);
    });
  }

  return string;
});
